module.exports = __webpack_public_path__ + "img/defult-head.7e651690.png";